module.exports = __webpack_public_path__ + "static/media/400416_01.a9d4b665.png";